import {
  UPDATE_ATTENDENCE,
  UPDATE_ATTENDANCE_TIME_INFORMATIONS,
  RESET_ATETENDANCE,
  UPDATE_AVATAR_ATTENDANCE,
  UPDATE_AGENT_DEFAULT_CAMPAIGN,
  SET_USER_ADDED,
  SET_ORG_UNIT_INFORMATION,
  UPDATE_ACK_CALL_REQUEST,
  UPDATE_ACK_CALL_VOLUME,
  SET_ORGANIA_OPEN_URL_DIALOG,
  SET_ORGANIA_DONT_ASK_AGAIN,
  UPDATE_WEBRTC_AUTO_RECONNECT,
  UPDATE_AGENT_ABSENT_STATUS,
  SET_NOTIFICATIONS,
} from '../../mutation-types';
import OrganiaService from '../../../services/organia-service';
import AgentService, {
  putChatNotification,
  putWhatsappNotification,
  putVoiceNotificationConnectionLost,
} from '../../../services/agent-service';
import { getStatusAgentChannels } from '@/services/agent-service';
import Client from '../../../weon/message-broker/Client';
import { updateAvatar } from '@/services/avatars-service';
import { generateQueueToListen } from '@/shared/utils/message-broker-helpers';
import { addToCall, removeFromCall } from '../../../services/voice-service';

const actions = {
  resetPassword({ commit }, params) {
    return AgentService.changeAgentPassword(
      params.identifier,
      params.password,
    ).then((response) => {
      if (response.status == 200) {
        return true;
      }
      return false;
    });
  },
  getAgentInformation({ commit }, identifier) {
    return AgentService.getAgentById(identifier).then((response) => {
      return response.data;
    });
  },
  getAgent({ commit, dispatch }, { identifier, channels }) {
    return AgentService.getAgentById(identifier).then((response) => {
      const agentId = response.data.agentId;
      const queueToListen = generateQueueToListen(agentId);
      return dispatch(
        'updateQueueToListenMessageBroker',
        { queueToListen, agentId },
        { root: true },
      ).then(() => {
        new Client(queueToListen);
        response.data.logged = true;
        response.data.loginIdentifier = agentId;
        response.data.channels = channels;
        commit(UPDATE_ATTENDENCE, response.data);
        return dispatch('getAgentTimeInformations', agentId);
      });
    });
  },

  addToCall({ dispatch }, info) {
    // ThirdPersonAdded
    return addToCall(info);
  },
  removeFromCall({ dispatch }, info) {
    // ThirdPersonAdded
    return removeFromCall(info);
  },
  setUserAdded({ commit }, body) {
    commit(SET_USER_ADDED, body);
  },

  getAgentTimeInformations({ commit, dispatch }, agentId) {
    return AgentService.timeInformations(agentId).then((timeInformations) => {
      commit(UPDATE_ATTENDANCE_TIME_INFORMATIONS, timeInformations.data);
      dispatch('jobs/updateTimeJobs', timeInformations.data, { root: true });
    });
  },

  getStatusAgent({ dispatch }, agentId) {
    getStatusAgentChannels(agentId)
      .then((status) =>
        dispatch('channel/updateStatusChannels', status, { root: true }),
      )
      .catch(console.log);
  },

  updateAttendence({ commit }, data) {
    commit(UPDATE_ATTENDENCE, data);
  },

  updateAvatar({ commit }, { avatar, agentId }) {
    return updateAvatar(agentId, avatar.id).then(() => {
      commit(UPDATE_AVATAR_ATTENDANCE, avatar);
    });
  },

  disconnectClient({ rootState }) {
    const queue = rootState.system.queueListenerMessageBroker;
    new Client(queue, true).unsubscribeFromQueueAndDisconnect();
  },

  updateDefaultCampaign({ commit }, { agentId, channel, campaignId }) {
    return AgentService.updateAgentDefaultCampaign(
      agentId,
      channel,
      campaignId,
    ).then((response) => {
      commit(UPDATE_AGENT_DEFAULT_CAMPAIGN, {
        channel: response.data.channel,
        campaignId: response.data.campaignId,
      });
    });
  },

  reset({ commit }) {
    commit(RESET_ATETENDANCE);
  },
  setOrgUnitInformation({ commit }, orgUnitId) {
    return AgentService.getOrgUnitInformation(orgUnitId).then((response) => {
      commit(SET_ORG_UNIT_INFORMATION, response.data[0]);
    });
  },
  updateAckCallRequest({ commit }, ackCallStatus) {
    commit(UPDATE_ACK_CALL_REQUEST, ackCallStatus);
  },
  updateAckCallVolume({ commit }, { agentId, volume }) {
    return AgentService.updateAckCallVolume(agentId, volume).then(() => {
      commit(UPDATE_ACK_CALL_VOLUME, volume);
    });
  },
  setOrganiaDialogStatus({ commit }, value) {
    commit(SET_ORGANIA_OPEN_URL_DIALOG, value);
  },
  setOrganiaDontAskAgain({ commit }, value) {
    commit(SET_ORGANIA_DONT_ASK_AGAIN, value);
  },
  removeOrganiaChurnBusterRisk({ dispatch, state }, params) {
    params.agent_id = state.Attendance.agentId;

    return OrganiaService.removeChurnRisk(params)
      .then((response) => {
        dispatch(
          'showSnackbar',
          {
            text: 'organia.churnBusterJustificationDialog.removeChurnRiskSuccess',
            type: 'success',
          },
          { root: true },
        );
        return true;
      })
      .catch((error) => {
        dispatch(
          'showSnackbar',
          {
            text: 'organia.churnBusterJustificationDialog.removeChurnRiskError',
            type: 'error',
          },
          { root: true },
        );
        return false;
      });
  },
  updateWebRTCAutoReconnect({ commit }, { agentId, webRtcAutoReconnect }) {
    return AgentService.updateWebRTCAutoReconnect(
      agentId,
      webRtcAutoReconnect,
    ).then(() => {
      commit(UPDATE_WEBRTC_AUTO_RECONNECT, webRtcAutoReconnect);
    });
  },
  removeAgentAbsentStatus({ commit }, agentId) {
    return new Promise((resolve) => {
      AgentService.removeAgentAbsentStatus(agentId).then((response) => {
        commit(UPDATE_AGENT_ABSENT_STATUS, response.data);
        resolve(true);
      });
    });
  },
  async setWhatsappNotification({ dispatch, commit }, { agentId, notify }) {
    notify = notify ? 1 : 0;
    try {
      await putWhatsappNotification(agentId, notify);
      commit(SET_NOTIFICATIONS, {
        type: 'notifyWhatsAppMessage',
        value: notify,
      });
      dispatch(
        'showSnackbar',
        {
          text: 'Preferências de notificação de whatsApp atualizada com sucesso',
          type: 'success',
        },
        { root: true },
      );
    } catch (err) {
      dispatch(
        'showSnackbar',
        {
          text: err,
          type: 'error',
        },
        { root: true },
      );
    }
  },
  async setChatNotification({ dispatch, commit }, { agentId, notify }) {
    notify = notify ? 1 : 0;
    try {
      await putChatNotification(agentId, notify);
      commit(SET_NOTIFICATIONS, { type: 'notifyChatMessage', value: notify });
      dispatch(
        'showSnackbar',
        {
          text: 'Preferências de notificação de chat atualizada com sucesso',
          type: 'success',
        },
        { root: true },
      );
    } catch (err) {
      dispatch(
        'showSnackbar',
        {
          text: err,
          type: 'error',
        },
        { root: true },
      );
    }
  },
  async setVoiceNotificationConnectionLost(
    { dispatch, commit },
    { agentId, notify },
  ) {
    notify = notify ? 1 : 0;
    try {
      await putVoiceNotificationConnectionLost(agentId, notify);
      commit(SET_NOTIFICATIONS, {
        type: 'notifyVoiceConnectionLost',
        value: notify,
      });
      dispatch(
        'showSnackbar',
        {
          text: 'Preferências de notificação de conexão de voz atualizada com sucesso',
          type: 'success',
        },
        { root: true },
      );
    } catch (err) {
      dispatch(
        'showSnackbar',
        {
          text: err,
          type: 'error',
        },
        { root: true },
      );
    }
  },
};

export default actions;
